import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ListMessageLogPaginateRes } from 'app/interfaces/responses/List/listMessageLogPaginateRes';
import { PROCESSING_STATUS, PROCESSING_STATUS_TRANSLATIONS } from 'common/constants/queue.constants';
import { DialogGeneral } from '../../DialogGeneral';

export interface DialogConfigsAddData {
    message: ListMessageLogPaginateRes;
}

@Component({
    selector: 'dialog-jobs-message-details',
    templateUrl: 'dialog-jobs-message-details.html',
    encapsulation: ViewEncapsulation.None,
})
export class DialogJobsMessageDetails extends DialogGeneral {
    processingStatus = PROCESSING_STATUS;
    statusLabel: string;
    body: any;

    constructor(
        public dialogRef: MatDialogRef<null>,
        public dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: DialogConfigsAddData
    ) {
        super(dialogRef);

        this.statusLabel = PROCESSING_STATUS_TRANSLATIONS[data.message.status];
        // Prettify payload string
        let payloadObject = JSON.parse(data.message.payload);
        this.body = JSON.parse(payloadObject.Body);
    }
}
